import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { EventTypeNode, IEventTypeNode } from "../eventType/eventTypeNode";
import { IdColorTitle, IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { EventSettingSimple, IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";

export interface IEventEditNew {
    urgencyClassId: string;
    companies: ICompanyMenuItem[];
    units: IIdTitleNode[];
    urgencyClasses: IIdColorTitle[];
    eventTypeNodes: IEventTypeNode[];
    eventTypeBNodes: IEventTypeNode[];
    eventTypeCNodes: IEventTypeNode[];
    eventSetting: IEventSettingSimple;
}

export class EventEditNew implements IEventEditNew {
    urgencyClassId: string;
    companies: ICompanyMenuItem[];
    units: IdTitleNode[];
    urgencyClasses: IdColorTitle[];
    eventTypeNodes: EventTypeNode[];
    eventTypeBNodes: EventTypeNode[];
    eventTypeCNodes: EventTypeNode[];
    eventSetting: EventSettingSimple;

    constructor();
    constructor(obj: IEventEditNew);
    constructor(obj?: any) {
        this.urgencyClassId = obj && obj.urgencyClassId || "";
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.urgencyClasses = Base.getTypedArray(obj ? obj.urgencyClasses : null, IdColorTitle);
        this.eventTypeNodes = Base.getTypedArray(obj ? obj.eventTypeNodes : null, EventTypeNode);
        this.eventTypeBNodes = Base.getTypedArray(obj ? obj.eventTypeBNodes : null, EventTypeNode);
        this.eventTypeCNodes = Base.getTypedArray(obj ? obj.eventTypeCNodes : null, EventTypeNode);
        this.eventSetting = new EventSettingSimple(obj?.eventSetting);
    }
}